export default [
    {
        field: 'max_afp_uf',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Tope Máximo AFP',
            suffix: 'U.F.',
        },
        format: 'numeric',
        rules: [ 'required' ],
    },
    {
        field: 'max_fonasa_uf',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Tope Máximo FONASA',
            suffix: 'U.F.',
        },
        format: 'numeric',
        rules: [ 'required' ],
    },
    {
        field: 'max_health_uf',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Tope Máximo IPS',
            suffix: 'U.F.',
        },
        format: 'numeric',
        rules: [ 'required' ],
    },
    {
        field: 'max_unemployment_insurance_uf',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Tope Máximo Seguro Cesantía',
            suffix: 'U.F.',
        },
        format: 'numeric',
        rules: [ 'required' ],
    },
    {
        field: 'imm',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Renta Mínima Imponible',
            suffix: 'CLP',
        },
        format: 'currency',
        rules: [ 'required' ],
    },
    {
        field: 'max_apv_monthly_uf',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Tope Máximo Mensual APV',
            suffix: 'U.F.',
        },
        format: 'numeric',
        rules: [ 'required', 'isNotNegative' ],
    },
    {
        field: 'max_apv_yearly_uf',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Tope Máximo Anual',
            suffix: 'U.F.',
        },
        format: 'numeric',
        rules: [ 'required', 'isNotNegative' ],
    },
]
